window.addEventListener('load', () => {
    let ngpLoginWidgetReady = false;
    let ngpSignupWidgetReady = false;
    m.widgets.load();

    document.addEventListener('ngpSignupWidgetReady', () => {
        ngpSignupWidgetReady = true;
    }, { once: true, passive: true });

    document.addEventListener('ngpLoginWidgetReady', () => {
        ngpLoginWidgetReady = true;
    }, { once: true, passive: true });

    showAuthFormByRedirectParam();
    showSignUpFormByRedirectParam();

    /**
     * Show Auth Form for non-authorized users by redirectUrl parameter.
     */
    function showAuthFormByRedirectParam() {
        const redirectUrlPattern = 'redirectUrl=';
        const webinarInvitationQueryParam = 'webinar_invitation';
        const newCustomerQueryParam = 'new_customer';
        const isLoggedIn = document.body.classList.contains('register');
        const hasRedirectUrl = location.search.includes(redirectUrlPattern);
        const registrationRequired = location.search.includes(webinarInvitationQueryParam) && location.search.includes(newCustomerQueryParam);

        if (isLoggedIn) {
            return;
        }

        if (registrationRequired) {
            return openSignUpForm();
        }

        if (hasRedirectUrl) {
            openLoginForm();
        }
    }

    /**
     * Show SignUp Form for non-authorized users by redirectUrl parameter.
     */
    function showSignUpFormByRedirectParam() {
        const regex = new RegExp('dialog=open-account');
        const isLoggedIn = document.body.classList.contains('register');

        if (!isLoggedIn && location.search.match(regex)) {
            openSignUpForm();
        }
    }

    function openLoginForm() {
        const login = document.querySelector('ngp-auth-login');

        if (ngpLoginWidgetReady) {
            login.firstChild.click();
        } else {
            document.addEventListener('ngpLoginWidgetReady', () => {
                login.firstChild.click();
            }, { once: true, passive: true });
        }
    }

    function openSignUpForm() {
        const signup = document.querySelector('ngp-auth-signup');

        if (ngpSignupWidgetReady) {
            signup.firstChild.click();
        } else {
            document.addEventListener('ngpSignupWidgetReady', () => {
                signup.firstChild.click();
            }, { once: true, passive: true });
        }
    }
});
